import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { imageUrl } from 'app/frontend/base/helpers'

type Props = {
  address: string | undefined
  allDetails: wowaudit.DiscordChannelDetails[]
}

const DiscordChannelInfo = ({ address, allDetails }: Props) => {
  if (!address) return null

  const details = allDetails.find(
    (detail) =>
      detail.channelId === address || detail.webhookUrls.includes(address),
  )

  if (!details)
    return (
      <Tooltip>
        <TooltipTrigger>
          <span className='italic opacity-70'>Unknown channel</span>
        </TooltipTrigger>
        <TooltipContent>
          The channel details will be available once a notification has been
          sent to this channel
        </TooltipContent>
      </Tooltip>
    )

  return (
    <div className='flex items-center gap-2 min-w-0'>
      <Tooltip>
        <TooltipTrigger>
          <a
            href={`https://discord.com/channels/${details.serverId}`}
            target='_blank'
            rel='noreferrer'
            className='shrink-0'
          >
            <img
              className={`rounded-md w-5 h-5`}
              src={details.serverIconUrl}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null
                currentTarget.src = imageUrl('bnet-temp.png')
              }}
            />
          </a>
        </TooltipTrigger>
        <TooltipContent>{details.serverName}</TooltipContent>
      </Tooltip>

      <a
        href={`https://discord.com/channels/${details.serverId}/${details.channelId}`}
        target='_blank'
        rel='noreferrer'
        className='truncate min-w-0 flex-1'
      >
        #{details.name}
      </a>
    </div>
  )
}

export default DiscordChannelInfo
